module.exports = __webpack_public_path__ + "img/3_Cecum.70814e3a.png";